<template>
  <div>
    <div v-show="!choosedId">
      <div class="doclist-typelist"
           style="margin-top: 40px;">
        <!-- 专题 -->
        <div class="doclist-typelist-first">
          <div class="zy">按专题：</div>
          <div class="qb"
               :class="{'choosed':!choosedId}"
               @click="choosedCategory('')">培训课程</div>
          <ul v-if="categoryList">
            <li :class="{'type-active':item.id === choosedId}"
                v-for="(item, index) in categoryList"
                @click="choosedCategory(item.id)"
                :key="index">{{item.videoTypeName}}</li>
          </ul>
        </div>
        <!-- 一级分类 -->
        <div class="doclist-typelist-first">
          <div class="zy">按专业：</div>
          <div class="qb"
               :class="{'choosed':courseOneIndex === -1}"
               @click="chooseCourseOneIndex(-1)">全部</div>
          <ul v-if="courseTree">
            <li :class="index === courseOneIndex?'type-active':''"
                v-for="(item, index) in courseTree"
                @click="chooseCourseOneIndex(index,item)"
                :key="index">{{item.typeName}}</li>
          </ul>
        </div>
        <!-- 二级分类 -->
        <div class="doclist-typelist-second"
             v-if="courseTwoList">
          <ul style="margin-left: 132px;">
            <li :class="index === courseTwoIndex?'type-active':''"
                v-for="(item, index) in courseTwoList"
                @click="chooseCourseTwoIndex(index,item)"
                :key="index">{{item.typeName}}</li>
          </ul>
        </div>
        <!-- 讲师分类 -->
        <div class="doclist-typelist-first"
             v-if="teacherList">
          <div class="zy">按讲师：</div>
          <div class="qb"
               :class="{'choosed':teacherIndex === -1}"
               @click="chooseTeacher(-1)">全部</div>
          <ul>
            <li :class="index === teacherIndex?'type-active':''"
                v-for="(item, index) in teacherList"
                @click="chooseTeacher(index)"
                :key="index">{{item.name}}</li>
          </ul>
        </div>
        <!-- 供应商分类 -->
        <!-- <div class="doclist-typelist-first"
             v-if="resourceCodeList">
          <div class="zy">按供应商：</div>
          <div class="qb"
               :class="{'choosed':!calssForm.resourceCode}"
               @click="choosedSupplier('')">全部</div>
          <ul>
            <li :class="{'type-active':calssForm.resourceCode === item.resourceCode}"
                v-for="(item, index) in resourceCodeList"
                @click="choosedSupplier(item.resourceCode)"
                :key="index">{{item.resourceName}}</li>
          </ul>
        </div> -->
        <!-- 收费 -->
        <div class="doclist-typelist-first">
          <div class="zy">按收费：</div>
          <!-- <div class="qb"
              :class="{'choosed':teacherIndex === -1}"
              @click="chooseTeacher(-1)">全部</div> -->
          <ul>
            <li :class="{'type-active':true === calssForm.free}"
                @click="choosedFree(true)">免费</li>
            <li :class="{'type-active':false === calssForm.free}"
                @click="choosedFree(false)">收费</li>
          </ul>
        </div>
      </div>
      <!-- 其他分类 -->
      <div class="qtt">
        <div class="question-classify">
          <ul>
            <li :class="{'checked': calssForm.orderType===1}"
                class="cursor-pointer"
                @click="changeOrderType(1)">
              关注度
            </li>
            <li :class="{'checked': calssForm.orderType===2}"
                class="cursor-pointer"
                @click="changeOrderType(2)">
              最新
            </li>
            <li :class="{'checked': calssForm.orderType===3 || calssForm.orderType===4}"
                class="cursor-pointer"
                style="display: flex;"
                @click="changeOrderType(3)">
              价格
              <div class="sort_status">
                <i class="el-icon-caret-top"
                   v-show="calssForm.orderType !== 3"
                   :class="{'sort_status_selected': calssForm.orderType === 4}"></i>
                <i class="el-icon-caret-bottom"
                   v-show="calssForm.orderType !== 4"
                   :class="{'sort_status_selected': calssForm.orderType === 3}"></i>
              </div>
            </li>
            <!-- <li v-for="(data,index) in datalist2"
                :class="`${currentIndex===index?'checked':''}`"
                :key="index"
                @click="changeOrder(index)">{{data}}</li> -->
            <!-- <span v-if="index === 2 && a === 3 && currentIndex ===2">↓</span><span v-else-if="index === 2 && a===4 && currentIndex ===2">↑</span> -->
          </ul>
        </div>
      </div>
      <h2 class="tishi"
          v-if="courseList === null || courseList.length === 0">抱歉！没有搜到该资料</h2>
      <CourserList :courseList="courseList"></CourserList>
      <!-- 分页 -->
      <div class="doclist-pagination"
           v-if="courseList !== null && courseList.length !== 0">
        <div class="doclist-lastpage"
             @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''"
              v-for="(item, index) in pageList"
              :key="index"
              @click="changePage(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage"
             @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">
          共{{totalPage}}页，到第
          <input type="text"
                 v-model.number="jumpTargetPage" />页
        </div>
        <div class="doclist-jump"
             @click="jumpFarPage">确定</div>
      </div>
    </div>
    <div v-show="choosedId">
      <KnowledgeVideoList v-show="choosedId"
                          @choosedCategory="choosedCategory"
                          :choosedId="choosedId"></KnowledgeVideoList>
    </div>
  </div>
</template>
<script>
import KnowledgeVideoList from './knowledgeVideoList'
import CourserList from '../common/courserList'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      courseTree: null, // 课程类目
      teacherList: null,
      datalist2: ['关注度', '最新', '价格'],
      // currentIndex: 0,
      courseOneIndex: -1, // 课程一级类目选中
      courseTwoList: null, // 课程二级列表
      courseTwoIndex: -1, // 课程二级类目选中
      teacherIndex: -1, // 教师选中的
      courseList: [],
      currentPage: 1,
      totalPage: 4,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1,
      calssForm: {
        free: null, // 查询条件免费
        resourceCode: '',
        orderType: 5, // 排序条件
        courseName: ''
      },
      categoryList: [], // 专题列表
      resourceCodeList: [], // 供应商列表
      choosedId: '', // ''选中培训
      type: '' // know 知识社区
    }
  },
  components: {
    CourserList,
    KnowledgeVideoList
  },
  watch: {
    '$route.query': {
      handler: 'routerWatchFun'
    }
  },
  methods: {
    // 获取知识社区类目
    getKnowledgeCategory () {
      let list = []
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideotype/variableVideoLevel`)
        .then(({ data }) => {
          if (data.code === 0 && data.data && data.data.length) {
            list.push(...data.data)
            if (this.type === 'know') {
              console.log(this.$route.query.menuType, 'this.$route.query.menuType')
              if (this.$route.query.menuType) {
                this.choosedCategory(this.$route.query.menuType)
              } else {
                this.choosedCategory(list[0].id)
              }
            }
          }
          this.categoryList = list
        })
    },
    routerWatchFun () {
      // let courseSearch = JSON.parse(this.$route.query.courseSearch)
      // this.courseOneIndex = courseSearch.courseOneIndex
      // this.courseTwoList = courseSearch.courseTwoList
      // this.courseTwoIndex = courseSearch.courseTwoIndex
      // this.teacherIndex = courseSearch.teacherIndex
      // this.calssForm = courseSearch.calssForm || {
      //   free: null, // 查询条件免费
      //   resourceCode: '',
      //   orderType: 5, // 排序条件
      //   courseName: ''
      // }
      sessionStorage.setItem('courseQuery', JSON.stringify(this.$route.query))
      this.getDataList()
    },
    choosedCategory (id) {
      this.choosedId = id
      if (!id) {
        // 选中培训，清空选中
        this.chooseCourseOneIndex(-1)
      } else {
        // 知识社区
      }
    },
    // 类目
    getCategory () {
      this.$http.get(`/front/train/trainCourse/categoryNavigation`)
        .then(({ data: res }) => {
          this.courseTree = res.data.typeTree || []
          this.teacherList = res.data.teacherEntityList || []
          this.resourceCodeList = res.data.resourceCodeList || []
        })
    },
    // 点击一级
    chooseCourseOneIndex (index, item) {
      this.courseOneIndex = index
      this.courseTwoList = index === -1 ? null : item.child || null
      this.courseTwoIndex = -1
      this.routerPush({
        type: this.courseOneIndex === -1 ? null : this.courseTwoIndex === -1 ? this.courseTree[this.courseOneIndex].id : this.courseTwoList[this.courseTwoIndex].id
      })
    },
    // 点击二级
    chooseCourseTwoIndex (index, item) {
      this.courseTwoIndex = index
      this.routerPush({
        type: this.courseOneIndex === -1 ? null : this.courseTwoIndex === -1 ? this.courseTree[this.courseOneIndex].id : this.courseTwoList[this.courseTwoIndex].id
      })
    },
    // 选择教师
    chooseTeacher (index) {
      this.teacherIndex = index
      this.routerPush({
        teacherId: this.teacherIndex === -1 ? null : this.teacherList[this.teacherIndex].id
      })
    },
    // 选择供应商
    choosedSupplier (id) {
      this.calssForm.resourceCode = id
      this.routerPush({
        resourceCode: this.calssForm.resourceCode
      })
    },
    // 收费免费
    choosedFree (val) {
      // 与陈江确认此处 双击取消选中
      if (val === this.calssForm.free) {
        this.calssForm.free = null
      } else {
        this.calssForm.free = val
      }
      this.routerPush({
        free: this.calssForm.free
      })
    },
    // 更改排序
    changeOrderType (val) {
      if (val === 3 && this.calssForm.orderType === 3) {
        this.calssForm.orderType = 4
      } else {
        if (val === this.calssForm.orderType || (this.calssForm.orderType === 4 && val === 3)) {
          this.calssForm.orderType = 1
        } else {
          this.calssForm.orderType = val
        }
      }
      this.routerPush({
        orderType: this.calssForm.orderType
      })
    },
    changePage (page) {
      this.routerPush({
        page: page
      })
    },
    routerPush (params = {}) {
      let query = {
        teacherId: this.$route.query.teacherId || null,
        type: this.$route.query.type || null,
        free: this.$route.query.free, // 查询条件免费
        resourceCode: this.$route.query.resourceCode || '',
        orderType: this.$route.query.orderType || 5, // 排序条件
        courseName: this.$route.query.courseName || '',
        page: 1,
        limit: 12,
        ...params,
        courseSearch: JSON.stringify({
          courseOneIndex: this.courseOneIndex,
          courseTwoList: this.courseTwoList,
          courseTwoIndex: this.courseTwoIndex,
          teacherIndex: this.teacherIndex,
          calssForm: this.calssForm
        })
      }
      this.$router.push({
        name: 'courseList',
        query: query
      })
    },
    // 查询数据
    getDataList () {
      this.$store.commit('setLoadStatus', true)
      let params = {}
      if (this.$route.query.page) {
        let free = this.$route.query.free
        if (typeof (free) === 'string') {
          if (free === 'false') {
            free = false
          } else {
            free = true
          }
        }
        params = {
          ...this.$route.query,
          free: free,
          page: Number(this.$route.query.page),
          limit: Number(this.$route.query.limit),
          courseSearch: JSON.stringify({
            courseOneIndex: this.courseOneIndex,
            courseTwoList: this.courseTwoList,
            courseTwoIndex: this.courseTwoIndex,
            teacherIndex: this.teacherIndex,
            calssForm: this.calssForm
          })
        }
      } else {
        params = {
          teacherId: null,
          type: null,
          free: null, // 查询条件免费
          resourceCode: '',
          orderType: 5, // 排序条件
          courseName: '',
          page: 1,
          limit: 12,
          courseSearch: JSON.stringify({
            courseOneIndex: this.courseOneIndex,
            courseTwoList: this.courseTwoList,
            courseTwoIndex: this.courseTwoIndex,
            teacherIndex: this.teacherIndex,
            calssForm: this.calssForm
          })
        }
      }
      this.$http.post(`/front/train/trainCourse/selectHomeAllTrainCourseList`, params).then(({ data: res }) => {
        if (res.code === 0) {
          this.courseList = res.data.data || []
          this.totalPage = Math.ceil(res.data.count / 12)
          this.setPageTo(params.page)
        } else {
          this.courseList = []
          this.totalPage = 0
          this.$message.error(res.msg)
        }
      }).catch(error => {
        this.courseList = []
        this.totalPage = 0
        if (error.response && error.response.data && error.response.data.message) {
          this.$message.error(error.response.data.message)
        }
      }).finally(() => {
        this.$store.commit('setLoadStatus', false)
      })
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.routerPush({
          page: newCurrent
        })
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    // 下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.routerPush({
          page: newCurrent
        })
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.routerPush({
          page: this.jumpTargetPage
        })
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    }
  },
  created () {
    if (!this.bus._events['getUserCourseList']) {
      this.bus.$on('getUserCourseList', (val) => {
        this.calssForm.courseName = val
        this.routerPush({
          courseName: this.calssForm.courseName
        })
      })
    }
    this.type = this.$route.query.type
    this.getCategory()
    this.getKnowledgeCategory()
    if (Cookies.get('getUserCourseListindex') !== '1') {
      this.getDataList()
    } else {
      this.calssForm.courseName = Cookies.get('searchName')
      this.bus.$emit('getUserchengecourseName', this.calssForm.courseName)
      this.getDataList()
    }
    Cookies.set('getUserCourseListindex', '')
    if (this.$route.query.courseSearch) {
      let courseSearch = {}
      try {
        courseSearch = JSON.parse(this.$route.query.courseSearch)
      } catch (error) {
        console.log(error)
      }
      this.courseOneIndex = courseSearch.courseOneIndex
      this.courseTwoList = courseSearch.courseTwoList
      this.courseTwoIndex = courseSearch.courseTwoIndex
      this.teacherIndex = courseSearch.teacherIndex
      this.calssForm = courseSearch.calssForm || {
        free: null, // 查询条件免费
        resourceCode: '',
        orderType: 5, // 排序条件
        courseName: ''
      }
    }
  }
}
</script>
<style scoped>
.doclist-typelist li {
  list-style: none;
}
.doclist-typelist {
  border-bottom: 1px solid #eeeeee;
  width: 1190px;
  margin: 0 auto;
  background-color: #ffffff;
}
.doclist-typelist-first {
  line-height: 20px;
  font-size: 14px;
  color: #333333;
  border-bottom: 1px solid #eeeeee;
}
.doclist-typelist-second {
  line-height: 40px;
  font-size: 14px;
  color: #333333;
  border-bottom: 1px solid #eeeeee;
}
.doclist-typelist-first {
  display: flex;
}
.doclist-typelist-first div {
  margin-right: 20px;
}
.doclist-typelist-first ul {
  /* width: 810px; */
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  color: #333333;
}
.doclist-typelist-first ul li {
  margin-right: 20px;
  line-height: 40px;
  user-select: none;
  cursor: pointer;
}
.doclist-typelist-first ul :hover {
  color: #1d65a8;
}
.doclist-typelist-second {
  display: flex;
}
.doclist-typelist-second div {
  margin-right: 20px;
}
.doclist-typelist-second ul {
  display: flex;
  flex-wrap: wrap;
}
.doclist-typelist-second ul :hover {
  color: #1d65a8;
}
.doclist-typelist-second ul li {
  margin-right: 20px;
  user-select: none;
  cursor: pointer;
}
.type-active {
  color: #1d65a8;
}
.type-active :hover {
  background: #1d65a8;
  color: #fff;
}
.train-container {
  width: 1190px;
  /* padding: 0 20px; */
  margin: 0 auto;
}
.courseList {
  /* border: 1px solid #000; */
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  align-content: flex-start;
}
.course {
  width: 280px;
  /* height: 149px; */
  /* border: 1px solid #000; */
  margin: 0 0 50px 0;
  overflow: hidden;
  background-color: #fff;
}
.course-margin {
  margin-left: 22px;
}
.course-img {
  cursor: pointer;
  /* width: 280px;
  height: 149px; */
}
.course-name {
  margin-top: 10px;
  padding-left: 12px;
  padding-right: 12px;
  height: 22px;
  line-height: 22px;
  font-size: 16px;
  color: #262626;
  cursor: pointer;
}
.course-info {
  padding-left: 12px;
  padding-right: 12px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #999;
  display: flex;
  justify-content: space-between;
}
.course-info-icon {
  color: #ff3116;
}
.course-info-price {
  font-size: 22px;
  color: #ff3116;
}
.qt {
  display: inline-block;
  width: 99px;
  height: 40px;
  text-align: center;
  border-left: 1px solid #eee;
  cursor: pointer;
  color: #333333;
  /* padding-bottom: 10px;
  padding-top: 10px; */
}
/* .qtt :hover {
  background: #1d65a8;
  color: #fff;
} */
.qttt {
  width: 97px;
  height: 20px;
  margin-bottom: 10px;
  margin-top: 10px;
  /* margin-left: 22.5px;
  margin-right: 22.5px;
  cursor: pointer;
  color: #333333; */
}
.question-classify ul {
  width: 100%;
  height: 40px;
  list-style: none;
  padding: 0;
}
.question-classify ul li {
  float: left;
  padding: 0 30px;
  color: #333;
  cursor: pointer;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  line-height: 40px;
  height: 40px;
}
.question-classify ul li:hover {
  background: #1d65a8;
  color: #fff;
}
.question-classify ul li:first-child {
  border-left: 0;
}
.sort_status {
  font-size: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #bebebe;
}
.sort_status_selected {
  color: #fff;
}
.question-classify ul li.checked {
  background: #1d65a8;
  color: #fff;
}
.zy {
  /* width: 48px; */
  /* height: 17px; */
  color: #333333;
  font-size: 14px;
  margin-left: 20px;
  flex-shrink: 0;
  line-height: 40px;
}
.qb {
  /* width: 24px; */
  /* height: 17px; */
  color: #333333;
  font-size: 14px;
  cursor: pointer;
  flex-shrink: 0;
  line-height: 40px;
}
.qb:hover {
  color: #1d65a8;
}
.choosed {
  /* background-color: #1d65a8;
  color: #fff; */
  color: #1d65a8;
}
.qtt {
  width: 1190px;
  margin: 0 auto;
  margin-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
  background-color: #ffffff;
}
.tishi {
  width: 1190px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  /* text-align: center; */
}
/* 分页区域样式 */
.doclist-pagination .pageactive {
  background: #1d65a8;
  color: #ffffff;
  border: 0;
}
.doclist-pagination {
  display: flex;
  height: 80px;
  padding: 20px 0;
  line-height: 40px;
  text-align: center;
  padding-left: 35px;
}
.doclist-pagination ul {
  display: flex;
}
.doclist-pagination ul li {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  border: 1px solid #eeeeee;
}
.doclist-omit {
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage {
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-nextpage {
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-pagejump {
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input {
  width: 35px;
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
  text-align: center;
}
.doclist-jump {
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-lastpage {
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage {
  user-select: none;
  cursor: pointer;
}
.pageDeavtive {
  box-sizing: border-box;
  border: 1px solid #eeeeee;
}
</style>
